import styled from 'styled-components';

import { btn, btnLink, secondary } from '../base';

interface buttonColor {
  buttonColor?: string;
  buttonFont?: string;
}

export const outlineButton = styled.button`
  ${btn(secondary)}
`;

export const outlineButtonLink = styled.div`
  ${btnLink(secondary)}
`;

export const text = styled.span<buttonColor>`
  font-style: normal;
  color: ${({ buttonColor }) => (buttonColor ? buttonColor : 'var(--text)')};
  font-size: ${({ buttonFont }) => (buttonFont ? buttonFont : 'var(--fs-body)')};
`;
